import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  button: {
    color: theme.palette.primary.contrastText,
    height: 48,
  },
});

const Page = ({ page, classes }) => {
  const { title, link, open_in_new_tab: openInNewTab } = page;
  return (
    <Button
      href={link}
      target={openInNewTab ? '_blank' : '_self'}
      rel={openInNewTab ? 'noopener noreferrer' : null}
      className={classes.button}
    >
      {title}
    </Button>
  );
};

Page.propTypes = {
  classes: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
};
Page.defaultProps = {};

export default withStyles(styles)(Page);
